"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxLayout = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = __importDefault(require("./styles"));
const BoxLayout = _ref => {
  let _ref$header = _ref.header,
    header = _ref$header === void 0 ? null : _ref$header,
    title = _ref.title,
    children = _ref.children,
    style = _ref.style;
  return react_1.default.createElement("div", {
    style: styles_1.default.container
  }, react_1.default.createElement("div", {
    style: styles_1.default.header
  }, title, header), react_1.default.createElement("div", {
    style: Object.assign(Object.assign({}, styles_1.default.default), style)
  }, children));
};
exports.BoxLayout = BoxLayout;
exports.default = exports.BoxLayout;